// edit: zhangmyh 2017-10-28 9:33 PM

export default {
  'aptitude': {
    title: '资质库维护',
    url: 'aptitude'
  },
  'basicInfomation': {
    title: '基本资料',
    url: 'information'
  },
  'applyClassifiton': {
    title: '采购分类',
    url: 'applyClassifiton'
  },
  'supplyReviewList': {
    title: '客商审核列表',
    url: 'ag_informreviewlist'
  },
  'supplyChangeList': {
    title: '客商变更列表',
    url: 'ag_informchangelist'
  },
  'supplyCertList': {
    title: '客商认证变更列表',
    url: 'ag_informcertificationlist'
  },
  'certApplyList': {
    title: '认证管理',
    url: 'sup_certapplylist'
  },
  'changList': {
    title: '基本档案变更列表',
    url: 'sup_informchangelist'
  },
  'navigation': {
    title: '首页导航说明维护',
    url: 'ag_navigation'
  },
  'onlineRetailerList': {
    title: '销售单位维护',
    url: 'ag_onlineRetailerList'
  },
  'qxLogList': {
    title: '启信数据统计',
    url: 'ag_qxlogList'
  },
  'hierarchy': {
    title: '供应商等级体系',
    url: 'hierarchy'
  },
  'greenChannel': {
    title: '非标准认证',
    url: 'greenChannel'
  },
  'greenChannelReport': {
    title: '非标准认证报告',
    url: 'greenChannelReport'
  },
  'greenChannelList': {
    //  title: '非标准通道认证列表',
    title: '非标准认证查询',
    url: 'greenChannelList'
  },
  'greenChannelReportList': {
    title: '非标准认证报告列表',
    url: 'greenChannelReportList'
  },
  'certification': {
    title: '新增指标',
    url: 'certification'
  },
  'certificationList0': {
    title: '现场认证指标',
    url: 'certificationList'
  },
  'certificationList1': {
    title: '供应商评价指标',
    url: 'certificationList'
  },
  'certificationList8': {
    title: '流程定义',
    url: 'certificationList'
  },
  'certificationQualify': {
    title: '资质审核指标',
    url: 'qualifyCertList'
  },
  'tplAllocation': {
    title: '模板分配',
    url: 'tplAllocation'
  },
  'templatelib_certification': {
    title: '认证模板',
    url: 'tplcertification'
  },
  'templatelib_evaluate': {
    title: '评价模板',
    url: 'tplevaluate'
  },
  'ag_hierarchicalLsit': {
    title: '供应商分级认证管理',
    url: 'ag_hierarchicalLsit'
  },
  'ag_evaluate': {
    title: '供应商评价单',
    url: 'ag_evaluate'
  },
  'ag_evaluateList': {
    title: '供应商评价管理列表',
    url: 'ag_evaluateList'
  },
  'certificationManage': {
    title: '认证管理',
    url: 'certificationManage'
  },
  'ag_evaluateReport': {
    title: '供应商评价单报告',
    url: 'ag_evaluateReport'
  },
  'performanceFeedback': {
    //  title: '反馈管理',
    title: '评价反馈查询',
    url: 'performancefeedback'
  },
  'performanceFeedbackAdd': {
    title: '新增反馈单',
    url: 'performancefeedbackadd'
  },
  'performanceFeedbackScan': {
    title: '查看反馈单',
    url: 'performancefeedbackscan'
  },
  'performanceDeal': {
    title: '奖惩管理',
    url: 'performancedeal'
  },
  'performanceDealEdit': {
    title: '新增奖惩单',
    url: 'performancedealedit'
  },
  'performanceDealScan': {
    title: '查看奖惩单',
    url: 'performancedealscan'
  },
  'performanceDealApprove': {
    title: '奖惩管理',
    url: 'performancedealapprove'
  },
  'performanceDealApproveEdit': {
    title: '审批奖惩单',
    url: 'performancedealapproveedit'
  },
  'performanceDealApproveScan': {
    title: '查看奖惩单',
    url: 'performancedealapprovescan'
  },
  'ag_hierarchicalEdit': {
    title: '查看反馈单',
    url: 'ag_hierarchicalEdit'
  },
  'certificationRecognitionEdit': {
    title: '查看认领反馈单',
    url: 'certificationRecognitionEdit'
  },
  'qualifyTemplate': {
    title: '资质审核模版',
    url: 'qualifytpl'
  },
  'qualifyTemplateList': {
    title: '资质审核模版管理',
    url: 'qualifytpllist'
  },
  'ag_feedBackEvaluateList': {
    title: '使用效果评价管理列表',
    url: 'ag_feedBackEvaluateList'
  },
  'sup_evaluateList': {
    title: '供应商评价详情',
    url: 'sup_evaluateList'
  },
  'ag_evaluate_sy': {
    title: '使用效果评价单',
    url: 'ag_evaluate_sy'
  },
  'qualificeaudit': {
    title: '资质审核',
    url: 'qualificeAudit'
  },
  'cerapprovalList': {
    title: '认证审核管理列表',
    url: 'cerapprovalList'
  },
  'pastCertification': {
    title: '以往认证记录',
    url: 'pastCertification'
  },
  'applyFieldView': {
    title: '产品试验',
    url: 'applyFieldView'
  },
  'ag_materialCertStep': {
    title: '供应分类等级认证方式管理',
    url: 'ag_materialCertStep'
  },
  'ag_evalReportList': {
    title: '供应商供应分类评价列表',
    url: 'ag_evalReportList'
  },
  'ag_evaluateIndicatorReport': {
    title: '供应分类评价报告',
    url: 'ag_evaluateIndicatorReport'
  },
  'ag_personClass': {
    title: '人员-供应分类分配',
    url: 'ag_personClass'
  },
  'ag_bid': {
    title: '招标项目数据导入',
    url: 'ag_bid'
  },
  'ag_contract': {
    title: '合同数据导入',
    url: 'ag_contract'
  },
  'ag_purchaseProject': {
    title: '采购信息数据导入',
    url: 'ag_purchaseProject'
  },
  'pc_materialClassView': {
    title: '供应分类查询',
    url: 'pc_materialClassView'
  },
  'customerCertification': {
    title: '客户认证',
    url: 'customerCertification'
  },
  'materialMapping': {
    title: '物料映射维护',
    url: 'materialMapping'
  },
  'materialMappingList': {
    title: '物料映射列表',
    url: 'materialMappingList'
  },
  'srmMessageList': {
    title: 'SRM认证结果',
    url: 'srmMessageList'
  },
  'pc_cerapprovalListView': {
    title: '标准认证查询',
    url: 'pc_cerapprovalListView'
  },
  'pc_performancedealView': {
    //  title: '奖惩管理',
    title: '奖惩管理查询',
    url: 'pc_performancedealView'
  },
  'certificationRecognition': {
    title: '认领认证结果管理',
    url: 'certificationRecognition'
  },
  'businessContractList': {
    title: '合同列表显示页面',
    url: 'businessContractList'
  },
  'businessContractDetail': {
    title: '合同详情页面',
    url: 'businessContractDetail'
  },
  'businessChannel': {
    title: '合同编辑页面',
    url: 'businessChannel'
  },
  'financeChannel': {
    title: '财务认领',
    url: 'financeChannel'
  },
  'financeChannelReport': {
    title: '财务认领报告',
    url: 'financeChannelReport'
  },
  'financeChannelList': {
    title: '财务认领查询',
    url: 'financeChannelList'
  },
  'personmanageList': {
    title: '人员查询',
    url: 'personmanageList'
  },
  'ag_sapLog': {
    title: '鞍山鞍钢钢铁财务系统客户接口日志',
    url: 'ag_sapLog'
  },
  'ag_miningIndustry': {
    title: '鞍山鞍钢矿业详情',
    url: 'ag_miningIndustry'
  },
  'ag_miningIndustryList': {
    title: '展示厅列表',
    url: 'ag_miningIndustryList'
  },
  'ag_miningIndustryAdd': {
    title: '展示厅详情',
    url: 'ag_miningIndustryAdd'
  },
  'ag_miningIndustryListShow': {
    title: '展示厅列表',
    url: 'ag_miningIndustryListShow'
  },
  'ag_bank': {
    title: '客商信息导入',
    url: 'ag_bank'
  },
  'ag_carouselPicList': {
    title: '轮播图维护列表页面',
    url: 'ag_carouselPicList'
  },
  'ag_carouselPicAdd': {
    title: '轮播图维护新增页面',
    url: 'ag_carouselPicAdd'
  }

}



// WEBPACK FOOTER //
// ./src/components/breadcrumbs/urllist.js